export const de = {
    'nav.today': "Tagesübersicht",
    'nav.calendar': "Nachfragekalender",
    'nav.rates': "Raten & Regeln",
    'nav.automation': "Automatisierung",
    'nav.audit': "Audit-Protokoll",
    'nav.settings': "Einstellungen",
    'sidebar.status': "Verbunden",
    'stat.occupancy': "Belegung",
    'stat.adr': "ADR (Durchschnittsrate)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Gesch. Umsatz",
    'stat.trend.vsLastWeek': "vs Vorwoche",
    'stat.trend.onPace': "Im Plan",
    'dashboard.actions.title': "Empfohlene Aktionen",
    'dashboard.actions.empty': "Keine Aktionen gefunden.",
    'filter.all': "Alle",
    'filter.pricing': "Preise",
    'filter.restriction': "Restriktionen",
    'action.approve': "Genehmigen",
    'action.reject': "Ablehnen",
    'action.risk.low': "geringes Risiko",
    'action.risk.medium': "mittleres Risiko",
    'action.risk.high': "hohes Risiko",
    'action.label.current': "Aktuell",
    'action.label.proposed': "Vorschlag",
    'action.metric.impact': "Auswirkung",
    'action.metric.why': "Grund",
    'action.status.executed': "Auto-Ausgeführt",
    'header.search': "Suchen...",
    'header.logout': "Abmelden",
    'auto.level.title': "Autopilot-Stufe",
    'auto.level.manual': "Manuell",
    'auto.level.manual.desc': "Sie genehmigen jede einzelne Empfehlung.",
    'auto.level.assisted': "Assistiert",
    'auto.level.assisted.desc': "Auto-Genehmigung bei geringem Risiko. Große Änderungen prüfen.",
    'auto.level.auto': "Vollautomatisch",
    'auto.level.auto.desc': "KI steuert Preise 24/7 innerhalb Ihrer Grenzen.",
    'auto.level.active': "Aktiv",
    'auto.guardrails.title': "Sicherheitsgrenzen",
    'auto.guardrails.maxIncrease': "Max. Tägl. Anstieg",
    'auto.guardrails.maxIncrease.desc': "Preisschocks vermeiden.",
    'auto.guardrails.maxDecrease': "Max. Tägl. Senkung",
    'auto.guardrails.maxDecrease.desc': "Preisdumping verhindern.",
    'auto.guardrails.minRate': "Mindestrate",
    'auto.guardrails.minRate.desc': "Niemals unter diesem Preis verkaufen (Netto).",
    'auto.emergency.title': "Notfall-Steuerung",
    'auto.emergency.label': "Not-Aus",
    'auto.emergency.desc': "Automatisierung sofort stoppen.",
    'auto.emergency.btn': "SYSTEM PAUSIEREN",
    'rates.filter.all': "Alle Zimmertypen",
    'rates.filter.next14': "Nächste 14 Tage",
    'rates.export': "Exportieren",
    'audit.table.time': "Zeit",
    'audit.table.actor': "Akteur",
    'audit.table.category': "Kategorie",
    'audit.table.action': "Aktion",
    'audit.table.details': "Details",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS-Verbindung",
    'settings.pms.connected': "Verbunden mit",
    'settings.pms.disconnect': "Trennen",
    'settings.account.title': "Konto",
    'settings.account.role': "Rolle",
    'settings.restart': "Onboarding neu starten",
    'onboard.title': "PMS verbinden",
    'onboard.desc': "Wählen Sie Ihr Property Management System für den Inventar-Sync.",
    'onboard.connecting': "Verbinde...",
    'onboard.connect': "Verbinden",
    'onboard.success.title': "Einrichtung abgeschlossen!",
    'onboard.success.desc': "Ihr Hotel **SynthHotel Berlin** ist jetzt synchronisiert.",
    'onboard.success.sub': "3 Zimmertypen, 14 Ratenpläne und 243 Buchungen importiert.",
    'onboard.btn.dashboard': "Zum Dashboard",
    'action.dynamic.weekend.title': "Rate erhöhen für starkes Wochenende",
    'action.dynamic.weekend.desc': "Belegung über 75% am Samstag, starke Nachfrage (+12 Zimmer in 24h).",
    'action.dynamic.minstay.title': "2 Nächte Mindestaufenthalt aktivieren",
    'action.dynamic.minstay.desc': "Taylor Swift Konzert angekündigt. 1-Nacht-Aufenthalte verhindern.",
    'action.dynamic.distress.title': "Rate senken (Schwache Nachfrage)",
    'action.dynamic.distress.desc': "Belegung nur 35% am Dienstag. Wettbewerber €10 günstiger.",
    'action.dynamic.gap.title': "Lückenfüller: CTA entfernen",
    'action.dynamic.gap.desc': "Einzelne Nacht verfügbar. Anreisesperre (CTA) aufheben.",
};
